import getTheme from '@unifyapps/ui/styles/theme';
import React, { useMemo } from 'react';
import CssVariableProvider from '@unifyapps/style/joy/CssVariableProvider';
import wrapInLayer from '@unifyapps/style/joy/wrapInLayer';
import createCache from '@emotion/cache';
import { CacheProvider as DefaultCacheProvider } from '@emotion/react';
import { stylisRemMultiplier } from '../plugins/stylis-rem-multiplier';
import { useDocElementsContext } from '@unifyapps/ui/providers/DocElementsContext';

const theme = getTheme({
  fontFamily: {
    body: 'Inter Variable',
    display: 'Inter Variable',
    text: 'Inter Variable',
    code: 'Source Sans Pro',
  },
});

export default function ThemeRegistry({
  children,
  renderInShadowDom,
}: {
  children: React.ReactNode;
  renderInShadowDom?: boolean;
}): React.JSX.Element {
  const { headEl } = useDocElementsContext();

  const cache = useMemo(
    () =>
      createCache({
        //key shouldn't conflict with other theme provider key.
        key: 'joy-dm',
        prepend: true,
        stylisPlugins: [wrapInLayer('emotion'), stylisRemMultiplier],
        container: headEl,
      }),
    [headEl],
  );

  return (
    <DefaultCacheProvider value={cache}>
      <CssVariableProvider
        storageWindow={null}
        // Default selector is :root, but in shadow dom we need to use :host so that these styles are inside shadow host/dom
        colorSchemeSelector={renderInShadowDom ? ':host' : undefined}
        theme={theme}
      >
        {children}
      </CssVariableProvider>
    </DefaultCacheProvider>
  );
}
